import { render } from "./AhdecoStatic.vue?vue&type=template&id=a5587c9c&scoped=true"
import script from "./AhdecoStatic.vue?vue&type=script&lang=js"
export * from "./AhdecoStatic.vue?vue&type=script&lang=js"

import "./AhdecoStatic.vue?vue&type=style&index=0&id=a5587c9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5587c9c"]])

export default __exports__